import FilterListIcon from '@material-ui/icons/FilterList';
import React, { useCallback, useMemo } from 'react';

import { ButtonLink, Space } from '@/components';
import { useFormVisible } from '@/hooks';
import { AnyTransactionPeriod } from '@/model/wallets/types';
import { noop } from '@/utils/functions';
import { Func } from '@/utils/ts';

import { TransactionFilterDialog, TransactionFilterTitle } from './components';

export interface TransactionFilterProps {
  'data-test'?: string;
  value: AnyTransactionPeriod;
  onChange: Func<[AnyTransactionPeriod], unknown>;
  onFilterVisibilityChanged?: Func<[boolean]>;
}

const TransactionFilter: React.FC<TransactionFilterProps> = ({
  value,
  onChange,
  onFilterVisibilityChanged = noop(),
  'data-test': dataTest,
}) => {
  const { visible, show, hide, withFormHide } = useFormVisible(false);
  const updateFilter = useMemo(
    () =>
      withFormHide(async (period: AnyTransactionPeriod) => {
        await onChange(period);
        await onFilterVisibilityChanged(false);
      }),
    [withFormHide, onChange, onFilterVisibilityChanged],
  );
  const doShow = useCallback(async () => {
    show();
    await onFilterVisibilityChanged(true);
  }, [onFilterVisibilityChanged, show]);
  const doHide = useCallback(async () => {
    hide();
    await onFilterVisibilityChanged(false);
  }, [onFilterVisibilityChanged, hide]);
  return (
    <>
      <ButtonLink
        data-test={dataTest && `${dataTest}-link`}
        onClick={doShow}
        style={{ justifyContent: 'center', display: 'flex', textDecoration: 'none' }}
      >
        <Space style={{ alignItems: 'center' }}>
          <TransactionFilterTitle data-test={dataTest && `${dataTest}-title`} value={value} />
          <FilterListIcon />
        </Space>
      </ButtonLink>
      {visible && (
        <TransactionFilterDialog
          data-test={dataTest && `${dataTest}-dialog`}
          value={value}
          onSelect={updateFilter}
          onClose={doHide}
        />
      )}
    </>
  );
};

export default TransactionFilter;
